import { Platforms, Communication } from "neo-games";
import { DataManager } from "./DataManager";
import { Scaling } from "../Utils/Scaling";
import { BalanceManager } from "./BalanceManager";
import { HtmlController } from "../HTMLComponents/HtmlController";
import { AppContext } from "../../Common/AppContext";
import { UserAction } from "../HTMLComponents/UserAction";
import { GameApp } from "../GameApp";
import { RetentionPanel } from "../Utils/RetentionPanel";
import { ModuleManager } from "./ModuleManager";
import { PageVisibilityHandler } from "../CustomComponents/PageVisibilityHandler";
import { EventData } from "neo-games/Engine/Plugins/EventTracker/EventTracker";
import { NotificationManager } from "./NotificationManager";
import { AutoplayData } from "neo-games/Engine/Platforms/IPlatforms";
import { GameManager } from "./GameManager";

var GameModules = Communication.Game.GameModules;

export class PlatformsManager {

    public static errorDismissedCallback: () => void | null;

    static create(): void {
        let pluginOrigin = "*";

        if (AppContext != null && AppContext.gameConfiguration != null) {
            if (AppContext.gameConfiguration.PluginOrigin != "") {
                pluginOrigin = AppContext.gameConfiguration.PluginOrigin;
            }

            Platforms.Platforms.getTimeDataFnc = DataManager.getTimeData;
            Platforms.Platforms.getGameTimeFnc = DataManager.getGameTime;
            Platforms.Platforms.createEmitter();

            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.AutoplayStop, PlatformsManager.stopAutoplay);
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.RestoreAutoplay, (autoplayData) => {
                PlatformsManager.restoreAutoplay(autoplayData);
            });
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.ResizeGame, PlatformsManager.resizeGame);
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.RefreshBalance, PlatformsManager.refreshBalance);
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.GamePlayStop, (disableChannel) => {
                PlatformsManager.gamePlayStop(disableChannel);
            });
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.GamePlayResume, PlatformsManager.gamePlayResume);
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.GamePlayFreeze, PlatformsManager.gamePlayFreeze);
            Platforms.Platforms.eventEmitter.on(
                Platforms.Platforms.GamePlayUnfreeze,
                PlatformsManager.gamePlayUnfreeze,
            );
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.GameAudioEnable, PlatformsManager.gameAudioEnable);
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.GameAudioMute, PlatformsManager.gameAudioMute);
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.GameAudioSet, (level: number) => {
                PlatformsManager.gameAudioSet(level);
            });
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.GameQuickSpin, (enabled: boolean) => {
                PlatformsManager.gameQuickSpin(enabled);
            });
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.ShowHelp, PlatformsManager.showHelp);
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.HideHelp, PlatformsManager.hideHelp);
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.ToggleHelp, PlatformsManager.toggleHelp);
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.ShowPaytable, PlatformsManager.showPaytable);
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.HidePaytable, PlatformsManager.hidePaytable);
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.TogglePaytable, PlatformsManager.togglePaytable);
            Platforms.Platforms.eventEmitter.on(
                Platforms.Platforms.PlatformCloseMenu,
                PlatformsManager.platformCloseMenu,
            );
            Platforms.Platforms.eventEmitter.on(
                Platforms.Platforms.PlatformCloseGame,
                PlatformsManager.platformCloseGame,
            );
            Platforms.Platforms.eventEmitter.on(
                Platforms.Platforms.PlatformUpdateUI,
                PlatformsManager.platformUpdateUI,
            );
            Platforms.Platforms.eventEmitter.on(
                Platforms.Platforms.PlatformErrorMessageDismissed,
                PlatformsManager.platformErrorMessageDismissed,
            );
            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.CreateNotification, (events: Array<EventData>) => {
                PlatformsManager.createNotification(events);
            });

            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.ResetRealityCheck, () => {
                void GameManager.gameClient.resetRealityCheck();
            });

            Platforms.Platforms.eventEmitter.on(Platforms.Platforms.CloseRealityCheck, () => {
                void GameManager.gameClient.closeRealityCheck();
            });

            Platforms.Platforms.create(
                AppContext.gameConfiguration.Platform,
                AppContext.gameConfiguration.PluginUrl,
                pluginOrigin,
                { gameKey: GameApp.key, lang: GameApp.language, clientHub: NotificationManager },
            );
        }
    }

    static stopAutoplay(): void {
        DataManager.Autoplay = false;
        DataManager.AutoplayAfterGamble = false;
        DataManager.AutoplayCount = "∞";
        DataManager.AutoplayLossLimit = "∞";
        DataManager.AutoplayWinLimit = "∞";
    }

    static restoreAutoplay(autoplayData: AutoplayData): void {
        DataManager.Autoplay = true;
        DataManager.AutoplayCount = autoplayData.autoplayCount;
        DataManager.AutoplayLossLimit = autoplayData.autoplayLossLimit;
        DataManager.AutoplayWinLimit = autoplayData.autoplayWinLimit;
        HtmlController.dispatchAction("AUTOPLAY");
    }

    static resizeGame(): void {
        Scaling.resizeRoot();
    }

    static refreshBalance(): void {
        BalanceManager.refreshBalance(true);
    }

    static gamePlayStop(disableChannel: boolean = false): void {
        // Stop autoplay
        PlatformsManager.stopAutoplay();

        // Disable channel module
        if (disableChannel) {
            if (ModuleManager.gambleActive()) {
                //ModuleManager.disableChannelModule(GameModules.Gamble);
            } else if (ModuleManager["freespinsActive"] && ModuleManager["freespinsActive"]()) {
                //ModuleManager.disableChannelModule(GameModules.Freespins);
            } else {
                ModuleManager.disableChannelModule(GameModules.Base);
            }
        }
    }

    static gamePlayResume(): void {
        // Restore game round
        if (ModuleManager.gambleActive()) {
            //ModuleManager.restoreGameRound(GameModules.Gamble);
        } else if (ModuleManager["freespinsActive"] && ModuleManager["freespinsActive"]()) {
            //ModuleManager.restoreGameRound(GameModules.Freespins);
        } else {
            ModuleManager.restoreGameRound(GameModules.Base);
        }
    }

    static gamePlayFreeze(): void {
        if (!Platforms.Platforms.canSpinOnCollect) {
            //handle freeze when idle (rc)
            PlatformsManager.stopAutoplay();
        }

        PageVisibilityHandler.Enabled = false;
        PageVisibilityHandler.pauseAll();
        HtmlController.dispatchActionAllowed = false;
        document.body.classList.add("freeze");
    }

    static gamePlayUnfreeze(): void {
        document.body.classList.remove("freeze");
        HtmlController.dispatchActionAllowed = true;
        PageVisibilityHandler.resumeAll();
        PageVisibilityHandler.Enabled = true;
    }

    static gameAudioEnable(): void {
        HtmlController.setSound(3);
    }

    static gameAudioMute(): void {
        HtmlController.setSound(0);
    }

    static gameAudioSet(level: number): void {
        HtmlController.setSound(level);
    }

    static showHelp(): void {
        let dipatchElementId = UserAction.ActionHelpOn;
        if (HtmlController.UiDispatchElements[dipatchElementId]) {
            let dipatchElement = HtmlController.UiDispatchElements[dipatchElementId][0];

            if (dipatchElement != null) {
                if (dipatchElement.instance.classList.contains(HtmlController.DisabledClass)) {
                    HtmlController.dispatchUiAction(UserAction.ActionHelpOn);
                }
            }
        }
    }

    static hideHelp(): void {
        let dipatchElementId = UserAction.ActionHelpOn;
        if (HtmlController.UiDispatchElements[dipatchElementId]) {
            let dipatchElement = HtmlController.UiDispatchElements[dipatchElementId][0];

            if (dipatchElement != null) {
                if (!dipatchElement.instance.classList.contains(HtmlController.DisabledClass)) {
                    HtmlController.dispatchUiAction(UserAction.ActionHelpOff);
                }
            }
        }
    }

    static toggleHelp(): void {
        let dipatchElementId = UserAction.ActionHelpOn;
        if (HtmlController.UiDispatchElements[dipatchElementId]) {
            let dipatchElement = HtmlController.UiDispatchElements[dipatchElementId][0];

            if (dipatchElement != null) {
                if (dipatchElement.instance.classList.contains(HtmlController.DisabledClass)) {
                    HtmlController.dispatchUiAction(UserAction.ActionHelpOn);
                } else {
                    HtmlController.dispatchUiAction(UserAction.ActionHelpOff);
                }
            }
        }
    }

    static showPaytable(): void {
        let dipatchElementId = UserAction.ActionPaytableOn;
        if (HtmlController.UiDispatchElements[dipatchElementId]) {
            let dipatchElement = HtmlController.UiDispatchElements[dipatchElementId][0];

            if (dipatchElement != null) {
                if (dipatchElement.instance.classList.contains(HtmlController.DisabledClass)) {
                    HtmlController.dispatchUiAction(UserAction.ActionPaytableOn);
                }
            }
        }
    }

    static hidePaytable(): void {
        let dipatchElementId = UserAction.ActionPaytableOn;
        if (HtmlController.UiDispatchElements[dipatchElementId]) {
            let dipatchElement = HtmlController.UiDispatchElements[dipatchElementId][0];

            if (dipatchElement != null) {
                if (!dipatchElement.instance.classList.contains(HtmlController.DisabledClass)) {
                    HtmlController.dispatchUiAction(UserAction.ActionPaytableOff);
                }
            }
        }
    }

    static togglePaytable(): void {
        let dipatchElementId = UserAction.ActionPaytableOn;
        if (HtmlController.UiDispatchElements[dipatchElementId]) {
            let dipatchElement = HtmlController.UiDispatchElements[dipatchElementId][0];

            if (dipatchElement != null) {
                if (dipatchElement.instance.classList.contains(HtmlController.DisabledClass)) {
                    HtmlController.dispatchUiAction(UserAction.ActionPaytableOn);
                } else {
                    HtmlController.dispatchUiAction(UserAction.ActionPaytableOff);
                }
            }
        }
    }

    static gameQuickSpin(enabled: boolean): void {
        //not all games has quickspin fnc, use object key as function name
        if (DataManager["quickspinSet"]) {
            DataManager["quickspinSet"](enabled);
        }
    }

    static platformCloseMenu(): void {
        HtmlController.dispatchUiAction("");
    }

    static platformCloseGame(): void {
        Platforms.Platforms.exitHandler = "platformsManager";
        GameApp.exit();
    }

    static platformUpdateUI(): void {
        RetentionPanel.revalidate();
    }

    static platformErrorMessageDismissed(): void {
        if (PlatformsManager.errorDismissedCallback != null) {
            PlatformsManager.errorDismissedCallback();
        }
    }

    static createNotification(events: Array<EventData>): void {
        if (AppContext.gameConfiguration.EventTrackerEnabled) {
            NotificationManager.sendMessage({
                application: "EventTrackingServer",
                service: "EventTracker",
                action: "event/log",
                data: { events: events },
            });
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Managers/PlatformsManager.ts
 **/